import { createMachine, InterpreterFrom, StateConfig, StateFrom } from 'xstate'

import { langCodes } from '../../../utils/siteSettings'

export interface OnboardPractitionerContext {
  siteLang?: string
}

export type OnboardPractitionerEvent = { type: 'CONTINUE' } | { type: 'RESTORE' }

type OnboardPractitionerState = {
  value:
    | 'initial'
    | 'legalAgreements'
    | 'rebateProgram'
    | 'dispensingOptions'
    | 'invalid'
    | 'complete'
  context: OnboardPractitionerContext
}

export const machine = createMachine<
  OnboardPractitionerContext,
  OnboardPractitionerEvent,
  OnboardPractitionerState
>({
  predictableActionArguments: true,
  id: 'onboard_practitioner',
  initial: 'initial',
  context: {},
  states: {
    initial: {
      on: {
        '*': 'legalAgreements',
      },
    },
    legalAgreements: {
      on: {
        CONTINUE: [
          {
            cond: ({ siteLang }) => siteLang === langCodes.en_US,
            target: 'rebateProgram',
          },
          {
            cond: ({ siteLang }) => siteLang !== langCodes.en_US,
            target: 'dispensingOptions',
          },
        ],
      },
    },
    rebateProgram: {
      on: {
        CONTINUE: [
          {
            cond: ({ siteLang }) => siteLang === langCodes.en_US,
            target: 'dispensingOptions',
          },
        ],
        RESTORE: [
          {
            cond: ({ siteLang }) => siteLang !== langCodes.en_US,
            target: 'dispensingOptions',
          },
        ],
      },
    },
    dispensingOptions: {
      on: {
        CONTINUE: 'complete',
      },
    },
    invalid: {
      on: {
        RESTORE: 'complete',
      },
    },
    complete: {
      type: 'final',
    },
  },
})

export type OnboardPractitionerMachine = typeof machine

export type OnboardPractitionerInterpreter = InterpreterFrom<OnboardPractitionerMachine>

export type OnboardPractitionerObserverCallback = (state: OnboardPractitionerStateObject) => void

export type OnboardPractitionerStateConfig = StateConfig<
  OnboardPractitionerContext,
  OnboardPractitionerEvent
>

export type OnboardPractitionerStateObject = StateFrom<OnboardPractitionerMachine>

export type OnboardPractitionerStateValue = OnboardPractitionerState['value']
